import React, { useContext, useEffect, useRef, useState } from "react";
import "./Dimmer.css";
import LinearSlider from "./Sliders/LinearSlider";
import { Context } from "../../../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Dimmer = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data,
  setData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);

    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeSlider = (value, button) => {
    setSelectedButton({
      id: button.id,
      sliderValue: value,
    });
  };

  const handleChangeStateButton = (e, button) => {
    setSelectedButton({
      id: button.id,
      sliderValue:
        selectedButton &&
        selectedButton.id == button.id &&
        selectedButton.sliderValue > 0
          ? 0
          : 100,
    });
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    const device = devices.find((dev) => dev.id == button.device_id);
    if (!device) {
      return;
    }
    let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
    selectedChannel[selectedChannel.length - (Number(button.digit) + 1)] = "1";
    let data1 = parseInt(selectedChannel.join(""), 2);
    let data2 = button.digit == 0 ? Math.floor(selectedButton.sliderValue) : 0;
    let data3 = button.digit == 1 ? Math.floor(selectedButton.sliderValue) : 0;
    let data4 = button.digit == 2 ? Math.floor(selectedButton.sliderValue) : 0;
    let data5 = button.digit == 3 ? Math.floor(selectedButton.sliderValue) : 0;
    let data6 = button.digit == 4 ? Math.floor(selectedButton.sliderValue) : 0;
    let data7 = button.digit == 5 ? Math.floor(selectedButton.sliderValue) : 0;
    let data10 =
      button.digit == 0 || button.digit == 1 || button.digit == 2 ? 100 : 101;
    let data11 =
      button.digit == 3 || button.digit == 4 || button.digit == 5 ? 100 : 101;
    setData({
      icon: null,
      name: button.name,
      data: [
        2,
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
        data10,
        data11,
      ],
      digit: button.digit,
      device: device,
    });
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      return (
        <div>
          <div
            className="dimmer mb-3 p-2"
            style={{
              boxShadow:
                selectedButton && selectedButton.id == button.id
                  ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                  : "0 0.25rem 1rem rgba(147, 158, 170, 0.45)",
            }}
          >
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-9 align-middle" style={{ padding: "0 1.7rem" }}>
                    <LinearSlider
                      value={
                        selectedButton && selectedButton.id == button.id
                          ? selectedButton.sliderValue
                          : 0
                      }
                      setValue={(value) => {
                        handleChangeSlider(value, button);
                      }}
                    />
                  </div>
                  <div className="col-3 text-center px-sm-3 my-auto">
                    <div className="text-center">
                      <p className="text-center p-0 m-0 d-block">
                        {button.name}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between pe-3">
                  <div>
                    <div className="form-check form-switch mb-2 p-0">
                      <label className="switch switch-success-app">
                        <input
                          type="checkbox"
                          className="switch-input"
                          onChange={(e) => handleChangeStateButton(e, button)}
                          checked={
                            selectedButton &&
                            selectedButton.id == button.id &&
                            selectedButton.sliderValue > 0
                              ? "checked"
                              : ""
                          }
                        />
                        <span
                          className="switch-toggle-slider"
                          style={{ transform: "rotate(180deg)" }}
                        >
                          <span className="switch-off"></span>
                          <span className="switch-on"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px" }}>
                      {"C" + (button.digit + 1)} - S/
                      {devices.find((d) => d.id == button.device_id)?.serial}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex justify-content-between border-bottom p-0"
        style={{ zIndex: 1, top: '0' }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
          {renderButtons()}
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Dimmer);
